import gsap from 'gsap';

/**
 * Sleep GSAP's ticker whenever no tween is actually doing work.
 *
 * GSAP's ticker is a self-rescheduling requestAnimationFrame loop, and on
 * Android WebView a pending rAF forces the compositor to produce real frames
 * at the display refresh rate EVEN IF NOTHING CHANGES - measured at ~100+ CPU
 * points of empty frames on a Galaxy S24+ once the ticker is awake. GSAP
 * wakes the ticker on every tween creation but never puts it back to sleep,
 * so the first tween of a session leaves the frame pipeline hot forever.
 * See docs/investigations/20260819-game-client-overheating.md (section 8d).
 *
 * Sleeping is safe and transparent: gsap.ticker.wake() is called internally
 * by the engine whenever a new tween is created, so the next card/chip
 * animation restarts the loop on its own. We only sleep when every tween in
 * the global timeline is paused or finished - a not-yet-started delayed
 * tween (unpaused, progress 0) keeps the ticker awake so its start is never
 * stalled.
 */
export function installGsapIdleSleep(intervalMs = 500): () => void {
  const id = window.setInterval(() => {
    const tweens = gsap.globalTimeline.getChildren(true, true, true);
    const idle = tweens.every((t) => t.paused() || t.progress() >= 1);
    if (idle) gsap.ticker.sleep();
  }, intervalMs);
  return () => window.clearInterval(id);
}

export default installGsapIdleSleep;
